<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader"; 
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue"; 
import StrIsoDuzelticiFaaliyet from "@/models/StrIsoDuzelticiFaaliyet"; 
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";  
export default {
  mixins: [Api, Sabit, StrIsoDuzelticiFaaliyet],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, formcombobox,
  },
  data() {
    return {
      title: "Düzeltici Faaliyet Açma",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları", 
        },
        {
          text: "Düzeltici Faaliyet Açma",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter:{
        Birimid: null,
        Donemid: null,
        Durum: null
      },
      DetayId: null,
      OPersonelid: null,
      KaliteRoleKontrol:false, 
    };
  },

  methods: {
    Get(){
      if(this.OPersonelid){ this.TableGet()}

    },
    TableGet() {
      var Filter = "&Desc=No&Acanid=" + this.OPersonelid 
      if(this.Filter.Acanbirimid != null){ Filter += "&Acanbirimid=" +this.Filter.Acanbirimid}
      if(this.Filter.Tespitsekliid != null){ Filter += "&Tespitsekliid=" +this.Filter.Tespitsekliid} 
 
      this.ActionsFilterGet({ Service: "StrIsoDuzelticiFaaliyet", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    getGunFarki(tarihStr) {
      if(!tarihStr){ return '-'}
      const bugun = new Date();
      const verilenTarih = new Date(tarihStr); 
      bugun.setHours(0, 0, 0, 0);
      verilenTarih.setHours(0, 0, 0, 0);

      const farkMs = bugun - verilenTarih; 
      const gunFarki = Math.floor(farkMs / (1000 * 60 * 60 * 24)); 
      return gunFarki > 0 ? gunFarki : '-';
    },
    
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin") || item.includes("StrIsoKaliteTemsilci")
      );
      if (YetkiSorgu.length != 0) this.KaliteRoleKontrol = true; 
    },

  isLink(text) {
    const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/i;
    return urlPattern.test(text);
  }

  }, 
  async created(){
    
    let Page= {
        PageNumber: "1",
        PageSize: "1"
      }
    let Filter = "&Eposta=" + this.UserEMail;
      var res = await this.ActionsFilterGet({
        Service: "OPersonel",
        Page: Page,
        Filter: Filter,
      }) 
        this.OPersonelid = res.Data[0].Id; 
       
     this.TableGet()
    this.MuneRolesControl();

  }
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
            

                  <formcombobox class="col-md-3" 
                  :FormDataType="FormDataType.Tespitsekliid"
                  :Value="Filter.Tespitsekliid"
                  :v="$v.Filter.Tespitsekliid"
                  @input="Filter.Tespitsekliid = $event"
                />
                <formcombobox class="col-md-3" 
                  :FormDataType="FormDataType.Acanbirimid"
                  :Value="Filter.Acanbirimid"
                  :v="$v.Filter.Acanbirimid"
                  @input="Filter.Acanbirimid = $event"
                /> 
                  
              
                <div class="col-sm-6">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4"  
                    @click="TableGet()">  <i class="mdi mdi-text-search me-1"></i>Filtreleme</button> 
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2 mt-4" v-b-modal.StrIsoDuzelticiFaaliyet 
                    @click="(DataUpdate = StrIsoDuzelticiFaaliyetData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i>Yeni Kayıt Ekle</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>DF No</th>
                      <th>DF Açılış Tarihi</th>
                      <th>DF Açan Kişi</th>
                      <th>DF Açılan Birim</th>
                      <th>Tespit Şekli</th>
                      <th>Uygunsuzluk Tanımı</th>
                      <th>Açılış Onayı</th>
                      <th>Yapılacak Düzeltici Faaliyet</th>
                      <th>Öngörülen Bitirme Tarihi</th>
                      <th>Öngörülen Bitirme Sapma</th>
                      <th>DF Onaylayan Kişi</th>
                      <th>Kanıt</th>
                      <th>Bitirme Tarihi</th>
                      <th>Kapanış Onayı</th> 
                      <th>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.No }}</th> 
                      <td>{{ Data.Acilistarih | formatDateTable }}</td>
                      <td>{{ Data.Acan }}</td>
                      <td>{{ Data.Acanbirim }}</td>
                      <td>{{ Data.Tespitsekli  }}</td>
                      <td>{{ Data.Uyumsuzluktanim  }}</td>
                      <td>{{ Data.Acilisonay == true ? 'X' : ''  }}</td>
                      <td>{{ Data.Yapiacakduzelticifaaliyet  }}</td>
                      <td>{{ Data.Ongorulenbitirmetarih | formatDateTable  }}</td>
                      <td>{{ getGunFarki(Data.Ongorulenbitirmetarih)}}</td>
                      <td>{{ Data.Onaylayan  }}</td>
                      <td> 
                        
                        <div class="row" v-for="(value, index) in JSON.parse(Data.Kanit)" :key="index"> 
                          <span  v-if="value.Tip == 'Text'  " > 
                            
<a  v-if="isLink(value.Kanit)" :href="value.Kanit"  target="_blank" class="text-primary text-decoration-underline">
        {{ value.Kanit }} </a> 
<span v-else>{{ value.Kanit }}</span> 

                          </span>
                          <a v-if="value.Tip == 'File'" :href="$config.FILES_URL + 'str/' + value.Kanit" target="_blanl">
                            <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i> {{ value.Kanit }}</a>
                        </div>

                      </td>
                      <td>{{ Data.Bitirmetarih | formatDateTable  }}</td>
                      <td>{{ Data.Kapanisonay == true ? 'X' : ''  }}</td>  
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">   
                          <i  v-b-tooltip.hover title="Düzenle" class="fas fa-pencil-alt" v-b-modal.StrIsoDuzelticiFaaliyet @click="(DataUpdate = Data), (AddEdit = 'Edit')" v-if="Data.Kapanisonay != true"></i>
                          <i   v-b-tooltip.hover title="Sil" class="fas fa-trash-alt" @click="Delete('StrIsoDuzelticiFaaliyet', Data.Id)"
                           v-if="Data.Kapanisonay != true && KaliteRoleKontrol"></i>  
                        </div>    
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="TableGet" :OPersonelid="OPersonelid"  />
      
      
    </Layout>
  </Loader>
</template>
